@import "../../../../../../shared/styles/base";

.chartActionGroup {
  width: auto;
  position: absolute;

  // This positioning is done using pixels because it should match the chart margins, which are always in px because they're SVG elements:
  top: 32px;
  right: 32px;
  max-width: calc(100% - 64px);
}

.ChartOptions_container {
  background: $white;
  box-shadow: $elevate-shadow-1;
  width: 18rem;
  border-radius: 0.25rem;
  padding: 1.5rem;

  > * + * {
    margin-top: 1rem;
  }
}

.chartTypeSelector {
  max-width: 15em;
}
